/**
 * Factory for creating GraphQLService instances based on platform
 */

import GraphQLService from './GraphQLService';
import NativeGraphQLService from './NativeGraphQLService';
import IGraphQLService from './IGraphQLService';
import { GraphQLPlatform } from './enums';

/**
 * Parameters for creating GraphQLService strategies
 */
export interface IGraphQLServiceFactoryParams {
  graphql?: {
    platform?: GraphQLPlatform | string;
    [key: string]: any;
  };
  isShellPortal?: boolean;
  jWebPlatform?: GraphQLPlatform | string;
}

/**
 * Factory Pattern to encapsulate GraphQLService creation logic
 */
export class GraphQLServiceFactory {
  /**
   * Creates the appropriate GraphQLService based on the platform
   */
  static createService(params: IGraphQLServiceFactoryParams): IGraphQLService {
    const { graphql, isShellPortal, jWebPlatform } = params;

    // Native GraphQL Service for non-web platforms
    if (graphql?.platform && graphql.platform !== GraphQLPlatform.WEB) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return new NativeGraphQLService(graphql.platform as any);
    }

    // Web GraphQL Service
    if (
      isShellPortal ||
      graphql?.platform === GraphQLPlatform.WEB ||
      jWebPlatform === GraphQLPlatform.WEB
    ) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return new GraphQLService(graphql as any);
    }

    // Default to Native with undefined platform
    return new NativeGraphQLService(undefined);
  }

  /**
   * Returns available service types
   */
  static getAvailableServices(): string[] {
    return ['GraphQLService', 'NativeGraphQLService'];
  }
}
